module.exports = __webpack_public_path__ + "img/9cecf4a66e6d8629b85e15dd96848966.png";